import React, { useState, useEffect, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import img from 'assets/images/logos.png'

import { showErrorToast } from 'utils/toast'
import Button from 'components/Button'
import CheckBox from 'components/Checkbox'
import Input from 'components/Input'
import PasswordInput from 'components/PasswordInput'
import validatorEmail from 'validators/email'
import { requestUserLogin } from 'api/user'
import { AuthContext } from 'providers/auth'
import CheckboxCheckedImage from 'assets/icons/checkbox-checked'
import CheckboxUnCheckedImage from 'assets/icons/checkbox-unchecked'

import { StyledLoginForm, LoginPageTitle, LogosImageWrapper, BottomNavigation, NavigationLi } from '../style'
import { FORGOT_PASSWORD_PATH } from 'routing/constants'

const LoginForm = () => {
  const history = useNavigate()
  const { setIsAuthenticated } = useContext(AuthContext)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isRememberMeActive, setIsRememberMe] = useState(false)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [error, setError] = useState({ error: '', field: '' })

  useEffect(() => {
    const rememberMeEmail = localStorage.getItem('rememberMeEmail')
    if (rememberMeEmail) {
      setEmail(rememberMeEmail)
    }
  }, [])

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleRememberMeToggle = () => {
    setIsRememberMe((s) => {
      return !s
    })
  }

  const isFormValid = () => {
    if (!email.length) {
      setError({ field: 'email', error: 'pleaseEnterYourCredentials' })
      return false
    }

    if (!validatorEmail(email)) {
      setError({ field: 'email', error: 'emailIsInvalid' })
      return false
    }

    if (!password.length) {
      setError({ field: 'password', error: 'pleaseEnterYourCredentials' })
      return false
    }

    setError({ field: '', error: '' })
    return true
  }

  const submitForm = async () => {
    if (!isFormValid()) {
      return
    }
    setIsFormSubmitted(true)
    try {
      const response = await requestUserLogin({ email, password })
      if (response.error) {
        setError(response)
        setIsFormSubmitted(false)
      } else {
        if (isRememberMeActive) {
          localStorage.setItem('rememberMeEmail', email)
        } else {
          localStorage.setItem('rememberMeEmail', '')
        }
        setIsAuthenticated(true)
        history('/sites')
      }
    } catch (e) {
      showErrorToast(<FormattedMessage id="somethingWentWrong" />, 'showBorder')
    }
  }

  return (
    <>
      <StyledLoginForm>
        <LoginPageTitle data-test="legend">
          <FormattedMessage id="signIn" />
        </LoginPageTitle>
        <Input
          field="email"
          value={email}
          label="email"
          placeholder="emailPlaceholder"
          onChange={handleEmailChange}
          error={error}
          margin="0 0 24px 0"
          marginBottomLabel="8px"
          marginBottomInput="24px"
          errorMarginTop="8px"
        />
        <PasswordInput
          field="password"
          value={password}
          label="password"
          placeholder="passwordPlaceholder"
          onChange={handlePasswordChange}
          error={error}
          margin="0 0 24px 0"
          marginBottomLabel="8px"
          marginBottomInput="24px"
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div 
              style={{ 
                display: 'grid', 
                placeItems: 'center', 
                height: '24px', 
                width: '24px', 
                cursor: 'pointer',
                marginRight: '8px'
              }}
              onClick={handleRememberMeToggle}
              data-test='remember-me-checkbox'
            >
              {isRememberMeActive ? (
                <div style={{ 
                  height: '16px', 
                  width: '16px', 
                  display: 'grid', 
                  placeItems: 'center', 
                  borderRadius: '2px', 
                  background: '#0AA1F4'
                }}>
                  <CheckboxCheckedImage />
                </div>
              ) : (
                <CheckboxUnCheckedImage />
              )}
            </div>
            <span>
              <FormattedMessage id="rememberMeCheckbox" />
            </span>
          </div>
          <Link data-test="forgot-password" style={{ color: 'rgba(32, 32, 32, 0.7)' }} exact strict to={FORGOT_PASSWORD_PATH}>
            <FormattedMessage id="forgotPassword" />
          </Link>
        </div>
        <Button onClick={submitForm} isPending={isFormSubmitted} dataTest="sign-in-submit" width='100%' type='primary'>
          <FormattedMessage id="signIn" />
        </Button>

        <LogosImageWrapper>
          <img style={{ width: '100%' }} src={img} />
        </LogosImageWrapper>

        <BottomNavigation>
          <Link
            data-test="agreement-terms-conditions"
            style={{ textDecoration: 'none' }}
            exact
            strict
            target="_blank"
            to="/terms-and-use"
          >
            <NavigationLi>Terms and use</NavigationLi>
          </Link>
          <NavigationLi><a href='https://www.birdlife.org/privacy-policy/' target="_blank" rel="noreferrer">Privacy policy</a></NavigationLi>
          <Link
            data-test="cookie"
            style={{ textDecoration: 'none' }}
            exact
            strict
            target="_blank"
            to="/cookie-settings"
          >
            <NavigationLi>Cookie Settings</NavigationLi>
          </Link>
        </BottomNavigation>
      </StyledLoginForm>
    </>
  )
}

export default LoginForm
